import React, { useContext, } from 'react';
import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import EcolineIconWhite from '../../assets/images/logo/logo-new.png';
import CustomizerContext from '../../_helper/Customizer';
import { useAuth } from '../../_helper/Auth/AuthProvider';
const SidebarLogo = () => {
  const { mixLayout, layout } = useContext(CustomizerContext);
  const { userData, authenticated } = useAuth();
  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  const getDashboardLink = () => {
    if (!authenticated || !userData.role) {
      return "/auth/login";
    }
    if (userData.role === 'admin') {
      return `${process.env.PUBLIC_URL}/dashboard`;
    } else if (userData.role === 'user') {
      return `${process.env.PUBLIC_URL}/app/home`;
    }
    return "/auth/login"; // Redirect to login if role is not recognized
  };

  const logoSrc = userData?.role === 'admin' ? EcolineIconWhite : EcolineIconWhite
  ;
  return (
    <div className='logo-wrapper'>
      {layout1 !== 'compact-wrapper dark-sidebar' && layout1 !== 'compact-wrapper color-sidebar' && mixLayout ? (
        <Link to={getDashboardLink()}>
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${logoSrc}`, alt: 'EcolineIcon', style: { maxWidth: '85%' } }} />
        </Link>
      ) : (
        <Link to={getDashboardLink()}>
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${logoSrc}`, alt: 'EcolineIcon', style: { maxWidth: '85%' } }} />
        </Link>
      )}
      {/* <div className='toggle-sidebar' onClick={openCloseSidebar}>
        <Grid className='status_toggle middle sidebar-toggle' />
      </div> */}
    </div>
  );
};

export default SidebarLogo;
